import { call, put, takeLatest, all, delay } from 'redux-saga/effects';
import api from '../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';

function* getUserAuthData() {
  try {
    const { data } = yield call(api.get, {
      route: `Authorisation/getUserauthdata`,
    });

    const userAuthData = data;
    yield put(Actions.setUserAuthData({ userAuthData }));
    yield put(Actions.getFactoryLabelsDetail({ userID: userAuthData.get('id') }));
  } catch (err) {
    notification('error', 'Error', err.message || err.toString());
    console.warn(err); // Handle exception
  }
}

function* getFactoryLabelsDetail({ userID }) {
  try {
    const { data } = yield call(api.get, {
      route: `Factory/GetFactoryLabelsDetailByUserid`,
      params: { userID },
    });
    const factoryLabelsDetail = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setFactoryLabelsDetail({ factoryLabelsDetail }));
  } catch (err) {
    notification('error', 'Error', err.message || err.toString());
    console.warn(err); // Handle exception
  }
}
function* fetchActivePackageDetail() {
  try {
    const { data } = yield call(api.get, {
      route: `Package/GetActivePackage`,
    });
    const activePackageData = data;
    yield put(Actions.setActivePackageDetail({ activePackageData }));
  } catch (err) {
    notification('error', 'Error', err.message || err.toString());
    console.warn(err); // Handle exception
  }
}

function* getRefreshToken() {
  while (true) {
    try {
      yield call(api.get, {
        route: `job/KeepAliveSession`,
      });
      yield delay(600000, true);
    } catch (err) {
      notification('error', 'Error', err.message || err.toString());
      console.warn(err); // Handle exception
    }
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.GET_USER_AUTH_DATA, getUserAuthData),
    takeLatest(ActionTypes.GET_REFRESH_TOKEN, getRefreshToken),
    takeLatest(ActionTypes.GET_FACTORY_LABELS_DETAILS, getFactoryLabelsDetail),
    takeLatest(ActionTypes.FETCH_ACTIVE_PACKAGE, fetchActivePackageDetail),
  ]);
}
